import { supabase } from '../supabase';

export function getSupportedMimeType() {
  const candidates = ['audio/webm;codecs=opus', 'audio/mp4', 'audio/wav'];
  for (const t of candidates) {
    if (typeof MediaRecorder !== 'undefined' && MediaRecorder.isTypeSupported(t)) {
      return t;
    }
  }
  return '';
}

export async function startRecording() {
  const mimeType = getSupportedMimeType();
  const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
  const options = mimeType ? { mimeType } : {};
  const recorder = new MediaRecorder(stream, options);
  const chunks = [];
  recorder.ondataavailable = (ev) => {
    if (ev.data && ev.data.size > 0) chunks.push(ev.data);
  };
  recorder.start(200);
  return { recorder, stream, chunks };
}

export function stopRecording(recorder, stream, chunks) {
  return new Promise((resolve, reject) => {
    if (!recorder) {
      reject(new Error('No recorder'));
      return;
    }
    recorder.onstop = () => {
      try {
        stream?.getTracks?.().forEach((t) => {
          try {
            t.stop();
          } catch (_) {}
        });
      } catch (_) {}
      const mime = recorder.mimeType || 'audio/webm';
      const blob = new Blob(chunks, { type: mime });
      resolve({ blob, mimeType: mime });
    };
    recorder.onerror = (ev) => {
      reject(ev.error || new Error('Recording failed'));
    };
    try {
      if (recorder.state === 'recording') recorder.stop();
      else if (recorder.state !== 'inactive') recorder.stop();
    } catch (e) {
      reject(e instanceof Error ? e : new Error(String(e)));
    }
  });
}

export async function processVoiceForJob(blob, mimeType, customerId) {
  try {
    const mt = mimeType || blob.type || '';
    const ext = mt.includes('webm')
      ? 'webm'
      : mt.includes('mp4') || mt.includes('m4a') || mt.includes('aac')
        ? 'm4a'
        : mt.includes('wav')
          ? 'wav'
          : 'webm';
    const formData = new FormData();
    formData.append('audio', blob, `voice.${ext}`);
    formData.append('customer_id', customerId);

    const { data, error } = await supabase.functions.invoke('ai-voice-to-job', { body: formData });

    if (error) {
      // The raw error object, never display text — callers localize it (KAN-590).
      return { error };
    }
    if (!data?.success) {
      return { error: { code: data?.error?.code, message: data?.error?.message } };
    }
    return { transcript: data.transcript, matched: data.matched };
  } catch (e) {
    return { error: e };
  }
}
